import { Grid, Typography } from "@mui/material";
import { IconBrandTelegram, IconPhoneCall } from "@tabler/icons-react";
import { Instagram, Location } from "iconsax-react";
import { IS_MOBILE } from "../../../constants/breakpoints";

export function ContactAtripa() {
    const contactList = [
        {
            id: 1,
            icon: <IconBrandTelegram />,
            label: "@educationbyatripa",
            isLink: true,
            href: IS_MOBILE ? "tg://resolve?domain=educationbyatripa" : "https://t.me/educationbyatripa",
        },
        {
            id: 2,
            icon: <Instagram />,
            label: "visa_by_atripa",
            isLink: true,
            href: IS_MOBILE ? "instagram://user?visa_by_atripa" : "https://instagram.com/visa_by_atripa",
        },
        {
            id: 3,
            icon: <IconPhoneCall />,
            label: "۰۹۳۷۸۳۸۷۰۰۹ | ۰۹۱۵۳۰۲۰۰۲۴",
            isLink: false,
        },
        {
            id: 4,
            icon: <Location />,
            label: "آدرس: پیامبر اعظم ۱۷ پلاک ۴ پیشگام پرتو گشت ویرا",
            isLink: false,
        },
    ];
    return (
        <Grid container flexDirection="column" rowGap={2} bgcolor="var(--white-gray-color)" p={2} borderRadius={5}>
            <Typography component="h3" color={"var(--primary-color)"} fontSize="1.5rem" fontWeight="bold" fontSize={{ xs: "1rem", md: "1.5rem" }}>
                مسیر ارتباط با آتریپا{" "}
            </Typography>

            <Grid container columnGap={5} rowGap={2}>
                {contactList.map(item =>
                    item.isLink ? (
                        <a
                            href={item?.href}
                            style={{ color: "var(--dark-gray)", display: "flex", alignItems: "center", fontWeight: "bold", gap: "8px" }}
                            display="flex"
                        >
                            {item.icon}
                            {item.label}
                        </a>
                    ) : (
                        <Typography
                            key={item.id}
                            display="flex"
                            columnGap={1}
                            alignItems="center"
                            component="span"
                            color={"var(--dark-gray)"}
                            fontSize="1rem"
                            fontWeight="bold"
                        >
                            {item.icon}
                            {item.label}
                        </Typography>
                    ),
                )}
            </Grid>
        </Grid>
    );
}
